import type { OptionApiModel } from '@api_patient/generated/clientv2/models';

// TODO: Use this when not injected anymore...
// export type ValidOptionId = `${typeof FormOption.ID_PREFIX}${number}`;
export type ValidOptionId = string;

export class FormOption {
	// Needs to use non id numbers. Seems to follow other specs that indicates
	// that only [a-zA-Z0-9] and ISO 10646 characters U+00A0 and higher, plus the
	// hyphen (-) and the underscore (_) are allowed.
	public static readonly ID_PREFIX = 'DFO_';

	public static composeOptionId(id: ValidOptionId): number {
		const int = id.replace(FormOption.ID_PREFIX, '');

		return parseInt(int, 10);
	}

	public static parseOptionId(id: number): ValidOptionId {
		return `${FormOption.ID_PREFIX}${id}`;
	}

	public readonly id: ValidOptionId;
	public readonly text: string;
	public readonly value: unknown | null;

	constructor(question: OptionApiModel) {
		this.id = this.parseOptionId(question.Id);
		// TODO PAT-426: Allow null?
		this.text = question.Text ?? '';
	}

	public composeOptionId(id?: ValidOptionId): number {
		return FormOption.composeOptionId(id ?? this.id);
	}

	public parseOptionId(id: number): ValidOptionId {
		return FormOption.parseOptionId(id);
	}
}
